import { FEATURED, SPONSORED } from '../constants';
import getCheckboxFilters from './get-checkbox-filters';
const getFilterValues = filterBy => filterBy.reduce((acc, filter) => {
  const [fieldName, ...values] = filter.split('/');
  const value = values.join('/');
  const previousValue = acc[fieldName];
  const finalValue = previousValue ? [...previousValue, value] : [value];
  acc[fieldName] = finalValue;
  return acc;
}, {});
const buildSetFilters = ({
  filterBy = [],
  filterByProperty = [],
  filterByFeatured,
  filterBySponsored
}) => {
  const checkboxFilters = [];
  getCheckboxFilters(checkboxFilters, FEATURED, filterByFeatured);
  getCheckboxFilters(checkboxFilters, SPONSORED, filterBySponsored);
  const shouldApplyFilterValues = filterBy.length && filterByProperty.length;
  if (!shouldApplyFilterValues) return {
    checkboxFilters,
    listFilterValues: {}
  };
  const listFilterValues = getFilterValues(filterBy);
  return {
    checkboxFilters,
    listFilterValues
  };
};
export default buildSetFilters;
//# sourceMappingURL=build-set-filters.js.map